define([
	"dojo/_base/declare",
	"csi",
	"csi/action/Controller",
	"csi/comm",
	"csi/comm/Aspera",
	"csi/comm/GetRequest",
	"csi/comm/PostRequest",
	"file-saver"
], function(declare,csi,Controller,comm,Aspera,GetRequest,PostRequest, FileSaver) {

	return declare(Controller, {
		toWriter: function() {
			let request;
			if (Aspera.isEnabled()) {
				let transferSpec = null;
				request = new PostRequest("Specification", "DownloadDataPackageZipAspera")
					.addParameter("URL", this.m_urlNode)
					.post({handleAs: "json"}).then(
						(response) => {
							transferSpec = response.data;
							return Aspera.downloadFileFromSpec(transferSpec);
						}
					).then(
						function() {
							if (transferSpec) {
								let deleteRequest = new PostRequest("SiteAdmin", "DeleteDataPackageZip");
								deleteRequest.addParameter("FileName", transferSpec.transfer_specs[0].transfer_spec.paths[0].destination);
								return deleteRequest.post();
							} else {
								return null;
							}
						}
					).then(
						(msg) => {
							this.postProcess();
						}
					);
			} else {
				const request = new PostRequest("Specification", "DownloadDataPackageZip")
					.addParameter("URL", this.m_urlNode);
				
				const callServerHttpPost = request.post({ handleAs: "blob" });

				//Save downloaded file
				callServerHttpPost.then((response) => {
					const fileName = this.getRequestActionId();
					FileSaver.saveAs(response.data, fileName); 
				});
			}
        }
    });
});